<template>
    <!--
    <div class="patientData">
        <el-tabs v-model="activeName" type="" style="height:100%;">
            <el-tab-pane label="详细数据" name="1">
                <div class="table_box">
                    <div class="search_box">
                        <el-form :model="searchForm" class="search_form" size="small">

                            <el-form-item label="填报日期：">
                                <el-date-picker
                                        v-model="searchForm.date"
                                        type="daterange"
                                        value-format="yyyy-MM-dd"
                                        range-separator="至"
                                        start-placeholder="开始日期"
                                        end-placeholder="结束日期"
                                        @change="dateChange"
                                >
                                </el-date-picker>
                            </el-form-item>
                            <el-form-item label="癌种:">
                                <div class="input_box">
                                    <div
                                            :class="searchForm.tumour === '' ? 'actived_btn' : ''"
                                            @click="clearSearch('tumour')"
                                            class="btn"
                                    >
                                        不限
                                    </div>
                                    <div
                                            v-for="(item, index) in tumourData"
                                            :key="index"
                                            :class="
                      searchForm.tumour === item.tumour ? 'actived_btn' : ''
                    "
                                            @click="changeCell(item.tumour, 'tumour')"
                                            class="btn"
                                    >
                                        {{ item.name }}
                                    </div>
                                </div>
                            </el-form-item>
                            <el-form-item label="省市：">
                              <el-cascader
                                v-model="searchForm.province_city"
                                :options="options"
                                @change="handleChange"
                                placeholder="请选择省市"
                              ></el-cascader>
                              <span style="color: #606266; padding: 0 12px">医院：</span>
                              <el-select
                                v-model="searchForm.hospital"
                                placeholder="请选择医院"
                                @change="getTableData"
                              >
                                <el-option
                                  v-for="item in tableHospitalData"
                                  :key="item.value"
                                  :label="item.name"
                                  :value="item.hospital_id"
                                >
                                </el-option>
                              </el-select>
                            </el-form-item>
                            <div style="display: flex; justify-content: space-between">
                                <el-form-item label="岗位：" style="display: flex">
                                    <div
                                            class="el-input__inner search_dialog_input"
                                            @click="showDep = true"
                                    >
                                        {{ departmentTitle }}
                                        <span class="holder_text" v-if="!departmentTitle"
                                        >请选择岗位</span
                                        >
                                    </div>
                                </el-form-item>
                                <el-form-item>
                                    <el-button
                                            type="primary"
                                            :loading="loadingExport"
                                            @click="exportData"
                                    >
                                        导出
                                    </el-button>
                                </el-form-item>
                            </div>
                        </el-form>
                    </div>

                    <el-table :data="tableData" stripe width="100%" :height="tableHeight">
                        <el-table-column
                                v-for="(item, index) in columnData"
                                :prop="item.prop"
                                :label="item.label"
                                :width="item.width"
                                :formatter="item.formatter"
                                :fixed="item.fixed"
                                show-overflow-tooltip
                                :key="index"
                        ></el-table-column>
                    </el-table>

                    <div class="bottom_page">
                        <page-view @getTableList="currentChange"
                                   :currentPage="currentPage"
                                   :pageSize="pageSize"
                                   :total="total"></page-view>
                    </div>

                    <el-dialog
                            title="岗位选择"
                            :visible.sync="showDep"
                            width="30%"
                            :modal-append-to-body="false"
                    >
                        <div style="height: 500px; overflow: hidden; overflow-y: auto">
                            <el-tree
                                    :data="treeData"
                                    node-key="department_id"
                                    :props="treeOptions"
                                    @node-click="clickNode"
                                    class="office_tree"
                                    highlight-current
                                    default-expand-all
                                    :expand-on-click-node="false"
                            >
                <span class="custom-tree-node" slot-scope="{ node, data }">
                  <span>{{ node.label }}</span>
                  <span @click.stop="" class="caozuo_btn"> </span>
                </span>
                            </el-tree>
                        </div>
                    </el-dialog>
                </div>
            </el-tab-pane>
            <el-tab-pane label="患者统计" name="2"></el-tab-pane>
        </el-tabs>
    </div>
    -->
    <div class="common_table_view context">
        <div class="header">
            <div class="search_box">
                <el-form :model="searchForm" class="search_form" size="small">

                    <el-form-item label="入组日期：">
                        <el-date-picker
                                v-model="searchForm.date"
                                type="daterange"
                                value-format="yyyy-MM-dd"
                                range-separator="至"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期"
                                :unlink-panels="true"
                                @change="dateChange"
                        >
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item label="癌种:">
                        <div class="input_box">
                            <div
                                    :class="searchForm.tumour === '' ? 'actived_btn' : ''"
                                    @click="clearSearch('tumour')"
                                    class="btn">
                                不限
                            </div>
                            <div
                                    v-for="(item, index) in tumourData"
                                    :key="index"
                                    :class="searchForm.tumour === item.tumour ? 'actived_btn' : ''"
                                    @click="changeCell(item.tumour, 'tumour')"
                                    class="btn"
                            >
                                {{ item.name }}
                            </div>
                        </div>
                    </el-form-item>
                    <el-form-item label="状态:">
                        <div class="input_box">
                            <div
                                    :class="searchForm.status === '' ? 'actived_btn' : ''"
                                    @click="clearSearch('status')"
                                    class="btn">
                                不限
                            </div>
                            <div
                                    v-for="(item, index) in statusData"
                                    :key="index"
                                    :class="searchForm.status === item.value ? 'actived_btn' : ''"
                                    @click="changeCell(item.value, 'status')"
                                    class="btn"
                            >
                                {{ item.name }}
                            </div>
                        </div>
                    </el-form-item>

                    <div style="width:100%; display: flex; justify-content: space-between">
                        <el-form-item label="岗位：">
                            <div style="display: flex">
                                <div
                                        class="el-input__inner search_dialog_input"
                                        @click="showDep = true"
                                >
                                    {{ departmentTitle }}
                                    <span class="holder_text" v-if="!departmentTitle"
                                    >请选择岗位</span
                                    >
                                </div>

                                <div class="btn" style="margin-left: 20px">
                                    <el-button plain type="primary" @click="getTableData()">搜索</el-button>
                                </div>
                                <div class="check_box" style="margin-left: 20px;display: flex">
                                    <span>（ </span>
                                    <span style="margin: 0 5px">
                                        <el-checkbox @change="getTableData()"
                                                     v-model="searchForm.has_test">
                                            含测试数据
                                        </el-checkbox>
                                    </span>
                                    <span> ）</span>
                                </div>
                            </div>
                        </el-form-item>
                        <el-form-item>
                            <el-button
                                    type="primary"
                                    :loading="loadingExport"
                                    @click="exportData"
                            >
                                导出
                            </el-button>
                            <el-button
                                    @click="downDataNow"
                            >
                                下载
                            </el-button>
                        </el-form-item>
                    </div>
                </el-form>
            </div>
        </div>
        <div class="table">
            <el-table :data="tableData" stripe width="100%" height="100%">
                <el-table-column
                        v-for="(item, index) in columnData"
                        :prop="item.prop"
                        :label="item.label"
                        :width="item.width"
                        :formatter="item.formatter"
                        :fixed="item.fixed"
                        show-overflow-tooltip
                        :key="index"
                ></el-table-column>
            </el-table>
        </div>
        <div class="bottom_page">
            <page-view @getTableList="currentChange"
                       :currentPage="currentPage"
                       :pageSize="pageSize"
                       :total="total"></page-view>
        </div>

        <el-dialog
                title="岗位选择"
                :visible.sync="showDep"
                width="30%"
                :modal-append-to-body="false">
            <div style="height: 500px; overflow: hidden; overflow-y: auto">
                <el-tree
                        :data="treeData"
                        node-key="department_id"
                        :props="treeOptions"
                        @node-click="clickNode"
                        class="office_tree"
                        highlight-current
                        default-expand-all
                        :expand-on-click-node="false">
                <span class="custom-tree-node" slot-scope="{ node, data }">
                  <span>{{ node.label }}</span>
                  <span @click.stop="" class="caozuo_btn"> </span>
                </span>
                </el-tree>
            </div>
        </el-dialog>
    </div>
</template>
<script>
    import {provinceAndCityData, CodeToText} from "element-china-area-data";
    import {mapState, mapMutations} from "vuex";
    import {clone, ssSet, ssGet, ssRemove,formatTime, lcGetWithAge} from "@/global/utils";
    import configs from "../../global/config"
    export default {
        components: {},
        data() {
            const showStatus = (row, column, cellValue, index) => {
                let text = '';
                this.statusData.forEach(v => {
                    if (cellValue == v.value) {
                        text = v.name
                    }
                });
                return text
            };
            const showSex = (row, column, cellValue, index) => {
                return cellValue == 1 ? "男" : cellValue == 2 ? "女" : "无";
            };
            const showCindilli = (row, column, cellValue, index) => {
                let text = '';
                this.drugList.forEach(v => {
                    if (cellValue == v.value) {
                        text = v.name
                    }
                });
                return text
            };
            const showLose = (row, column, cellValue, index) => {
                return cellValue == 1 ? "否" : cellValue == 2 ? "是" : "";
            };
            return {
                activeName: "1",
                showDep: false,
                searchForm: {
                    tumour: "",
                    status: "",
                    date: [],
                    department_id: "",
                    has_test: false,
                    // province_city: [],
                    // hospital: "",
                },
                departmentTitle: "",
                loadingExport: false,
                statusData: [
                    {
                        value: 1,
                        name: "疗程中",
                    },
                    {
                        value: 5,
                        name: "待跟进",
                    },
                    {
                        value: 6,
                        name: "待跟进（停药）",
                    },
                    {
                        value: 3,
                        name: "已脱落",
                    },
                    {
                        value: 4,
                        name: "未填报",
                    },
                ],
                tumourData: [
                    {name: "肺癌-腺癌", tumour: "肺癌-腺癌"},
                    {name: "肺癌-鳞癌", tumour: "肺癌-鳞癌"},
                    {name: "肺癌-突变耐药", tumour: "肺癌-突变耐药"},
                    {name: "肝癌", tumour: "肝癌"},
                    {name: "胆管癌", tumour: "胆管癌"},
                    {name: "妇癌", tumour: "妇癌"},
                    {name: "结直肠癌", tumour: "结直肠癌"},
                    {name: "食管癌", tumour: "食管癌"},
                    {name: "胃癌", tumour: "胃癌"},
                    {name: "血液", tumour: "血液"},
                    {name: "其他", tumour: "其他"},
                ],
                drugList: [
                    {
                        name: '信迪利单抗',
                        value: 1
                    },
                    {
                        name: '佩米替尼',
                        value: 2
                    },
                    {
                        name: '以上药物均未使用',
                        value: 0
                    }
                ],

                columnData: [
                    {label: "填报人", prop: "rep_name"},
                    {label: "BU", prop: "bussunit"},
                    {label: "AREA", prop: "area"},
                    {label: "区域", prop: "section", width: 120},
                    {label: "大区", prop: "region", width: 120},
                    {label: "地区", prop: "district", width: 120},
                    {label: "状态", prop: "medication_stage", width: 80, formatter: showStatus,},
                    {label: "患者编号", prop: "user_id", width: 100},
                    {label: "姓名", prop: "name", width: 90},
                    {
                        label: "性别",
                        prop: "sex",
                        width: 60,
                        formatter: showSex,
                    },
                    {label: "手机号", prop: "phone", width: 110},
                    {label: "就诊城市", prop: "province", width: 100},
                    {label: "就诊医院", prop: "hospital", width: 140},
                    {label: "就诊科室", prop: "department", width: 100},
                    {label: "就诊医生", prop: "doctor_name", width: 120},
                    {label: "上报日期", prop: "submit_date", width: 120},
                    {label: "入组日期", prop: "first_drug_date", width: 120},
                    {label: "癌种", prop: "tumour", width: 100},
                    {label: "分期", prop: "stage"},
                    {label: "治疗方案", prop: "schedule", width: 120},
                    {
                        label: "使用药物",
                        prop: "drug_code",
                        formatter: showCindilli,
                        width: 120,
                    },
                    {label: "已完成用药周期", prop: "medication_cycle"},
                    {label: "支数", prop: "medication_count"},
                    {label: "是否脱落", prop: "is_lose", formatter: showLose},
                    {label: "脱落原因", prop: "lose_reason1", width: 120},
                ],
                tableData: [],

                tableHospitalData: [],
                options: provinceAndCityData,
                treeData: [],
                treeOptions: {
                    label: "name",
                    children: "children",
                },

                tableHeight: null,

                total: 0,
                currentPage: 1,
                pageSize: 50,

                timer: null, // 轮询
            };
        },
        watch: {
            activeName() {
                console.log(this.activeName);
            },
        },
        methods: {
            currentChange(val) {
                this.currentPage = val;
                this.getTableData();
            },
            getParams() {
                // let province = this.searchForm.province_city[0]
                //     ? CodeToText[this.searchForm.province_city[0]]
                //     : "";
                // let city = this.searchForm.province_city[1]
                //     ? CodeToText[this.searchForm.province_city[1]]
                //     : "";
                // city = city == "市辖区" ? "" : city;
                let params = {
                    tumour: this.searchForm.tumour,
                    medication_stage: this.searchForm.status,
                    start_first_date: this.searchForm.date ? this.searchForm.date[0] : "",
                    end_first_date: this.searchForm.date ? this.searchForm.date[1] : "",
                    department_id: this.searchForm.department_id,
                    include_test: this.searchForm.has_test ? 2 : 1,
                    page: this.currentPage,
                    page_size: this.pageSize,
                    // province: province,
                    // city: city,
                    // hospital_id: this.searchForm.hospital,
                };
                return params;
            },
            getTableData(v = 1) {
                let params = this.getParams();
                this.httpPost("/user/patients", params).then((res) => {
                    this.tableData = res.data.data_list;
                    this.total = res.data.total;
                });
            },
            clearSearch(name) {
                this.searchForm[name] = "";
                this.getTableData();
            },
            dateChange() {
                this.getTableData();
            },
            changeCell(val, name) {
                this.searchForm[name] = val;
                this.getTableData();
            },
            handleChange(val) {
                this.getTableData();
            },
            clickNode(val) {
                this.departmentTitle = val.name;
                this.searchForm.department_id = val.department_id;
                this.showDep = false;
                this.getTableData();
                // console.log("clickNode----", val);
            },
            exportData() {
                console.log("exportData--------");
                let params = this.getParams();
                delete params.page_size;
                delete params.page;
                console.log(params);
                this.loadingExport = true;
                this.httpPost("/user/patients/export", params).then((res) => {
                    this.exportPolling(res.data.job_id);
                    ssSet('down_job_id', res.data.job_id)
                });
            },
            exportPolling(job_id) {
                let i = 0;
                this.timer = setInterval(() => {
                    i++;
                    this.httpGet("/user/patients/check_export", {
                        job_id: job_id,
                    }).then((res) => {
                        // console.log("---", res, i);
                        if (res.data.finished) {
                            clearInterval(this.timer);
                            ssRemove('down_job_id');
                            this.loadingExport = false;
                            let token = lcGetWithAge('token');
                            let url = `${res.data.url}?token=${token}`;
                            // console.log("0----finished", res.data.url, url);

                            let a = document.createElement('a');
                            document.body.appendChild(a);
                            a.href = url;
                            a.click();
                            a.remove()
                        }
                    });
                }, 2000);
            },

            downDataNow() {
                // 2022-06-17
                let time = (new Date()).getTime() - 3600*1000*24;
                let searchDate = formatTime(new Date(time)).time1;
                let token = lcGetWithAge('token');
                // console.log(window.location, '539');
                let href = window.location.origin;
                let baseUrl = configs.BASE_URL? configs.BASE_URL : href;
                let url = `${baseUrl}/web/api${configs.api_version}/local_file/download/patients/export/P明细数据_${searchDate}.xlsx?token=${token}`;
                // this.httpGet(url)
                let a = document.createElement('a');
                document.body.appendChild(a);
                a.href = url;
                a.click();
                a.remove()
            },

            getTree() {
                this.httpGet("/department").then((res) => {
                    this.treeData = res.data;
                });
            },
            getHospital() {
                this.httpGet("/hospital").then((res) => {
                    this.tableHospitalData = res.data.data_list;
                });
            },

            getDownFirst() {
                let job_id = ssGet('down_job_id');
                if (job_id) {
                    this.loadingExport = true;
                    this.exportPolling(job_id)
                }
            },
        },
        mounted() {
            this.getTree();
            // this.getHospital();
            this.getTableData();

            this.getDownFirst()
        },
        beforeDestroy() {
            clearInterval(this.timer);
        }
    };
</script>
<style lang="scss" scoped>
    .context {
        width: 100%;
        height: 100%;

        .header {
            .search_box {
                width: 100%;
            }
            .input_box {
                display: flex;
                .btn {
                    height: 25px;
                    line-height: 25px;
                    font-size: 0.875rem;
                    padding: 0 10px;
                    box-sizing: border-box;
                    margin: 5px 10px;
                    cursor: pointer;
                    white-space: nowrap;
                }
                .actived_btn {
                    box-sizing: border-box;
                    border: 1px solid #38adff;
                    border-radius: 3px;
                }
            }
        }
    }

    .search_dialog_input {
        background: #fff;
        border: 1px solid #dcdfe6;
        cursor: pointer;
        height: 35px;
        line-height: 35px;
        width: 350px;
        box-sizing: border-box;
        .holder_text {
            color: #dcdfe6;
        }
    }

</style>

<!--<style lang="scss">-->
<!--.patientData {-->
<!--.el-tabs__content {-->
<!--height: calc(100% - 55px);-->
<!--}-->
<!--.el-tab-pane {-->
<!--height: 100%;-->
<!--}-->
<!--}-->
<!--</style>-->